import { render } from "./AddIntervallePoidsModal.vue?vue&type=template&id=6ec5eeb6&ts=true"
import script from "./AddIntervallePoidsModal.vue?vue&type=script&lang=ts"
export * from "./AddIntervallePoidsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__